import { createContext, useContext, useEffect, useState } from 'react';
import {jwtDecode} from 'jwt-decode';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [userID, setUserID] = useState(null);
    const [userRole, setUserRole] = useState(null);
    const [isKyc, setIsKyc] = useState(false);

    const loadUserFromToken = () => {
        const token = localStorage.getItem('authToken');
        if (token) {
            try {
                const decodedToken = jwtDecode(token);
                setUserID(decodedToken?.id);
                setUserRole(decodedToken?.role);
                setIsKyc(decodedToken?.isKyc);
            } catch (error) {
                console.error('Invalid token:', error);
                setUserID(null);
                setUserRole(null);
            }
        } else {
            setUserID(null);
            setUserRole(null);
        }
    };

    useEffect(() => {
        loadUserFromToken();
    }, []);

    const login = (token) => {
        localStorage.setItem('authToken', token);
        loadUserFromToken(); 
    };
    
    const logout = () => {
        localStorage.removeItem('authToken');
        setUserID(null);
        setUserRole(null);
    };
    

    return (
        <AuthContext.Provider value={{ userID, setUserID , login, logout, userRole, setUserRole, isKyc}}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);